import { UserCredential } from "firebase/auth";
import { loginMethod } from "src/types";

const setLastLoginMethod = (method: loginMethod) => {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("lastLoginMethod", method);
  }
};

const postLogin = (result: UserCredential) => {
  // This gives you a Google Access Token. You can use it to access the Google API.
  // const credential = GoogleAuthProvider.credentialFromResult(result);
  // const token = credential!.accessToken;
  // The signed-in user info.

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const user = result.user;
};

export const postLoginGoogle = (result: UserCredential) => {
  setLastLoginMethod("Google");
  postLogin(result);
};

export const postLoginLocal = (result: UserCredential) => {
  setLastLoginMethod("Local");
  postLogin(result);
};

export const postLoginToken = (result: UserCredential) => {
  setLastLoginMethod("Token");
  window.localStorage.removeItem("emailForSignIn");

  const urlObj = new URL(window.location.href);
  const params = urlObj.searchParams;
  ["apiKey", "oobCode", "mode", "lang"].forEach((name) => {
    params.delete(name);
  });
  urlObj.search = params.toString();
  window.history.replaceState(null, "", urlObj.toString());

  postLogin(result);
};
